<article class="ai-message">

  <!-- ── User message ── -->
  <ng-container *ngIf="message.role === 'user'">
    <div class="ai-user-outer">
      <div class="ai-user-bubble">
        <div class="ai-user-bubble-header">
          <span class="ai-user-sender">You</span>
          <span class="ai-user-time">{{ displayTime(message.createdAt) }}</span>
        </div>
        <p class="ai-user-text">{{ message.text }}</p>
      </div>
    </div>
  </ng-container>

  <!-- ── Assistant message ── -->
  <ng-container *ngIf="message.role === 'assistant'">
    <div class="ai-assistant-wrap">

      <!-- Header: avatar + name + agent + time (all left-aligned) -->
      <div class="ai-msg-meta">
        <img src="/assets/media/eva/eva-mini.png" alt="Octy" class="ai-meta-avatar" />
        <span class="ai-meta-sender--octy">Octy</span>
        <span class="ai-meta-sep" aria-hidden="true">·</span>
        <span class="ai-meta-agent">{{ agentName }}</span>
        <span class="ai-meta-time">{{ displayTime(message.createdAt) }}</span>
      </div>

      <!-- Content card -->
      <div class="ai-response-card">
      <div class="ai-assistant-content">

        <div *ngIf="message.loadingLabel" class="ai-working-state">
          <span class="ai-working-dots" aria-hidden="true">
            <i></i><i></i><i></i>
          </span>
          <span>{{ message.loadingLabel }}</span>
        </div>

        <div *ngIf="message.streaming && message.text" class="ai-stream-plain">{{ message.text }}<span class="ai-stream-cursor" aria-hidden="true"></span></div>

        <div
          *ngIf="!message.streaming && message.text"
          class="ai-markdown"
          [class.ai-streamed-markdown]="!hasBlockType('action-items')"
          [class.ai-plain-narration]="hasBlockType('action-items')"
          [innerHTML]="renderMarkdown(message.text!)"
        ></div>

        <div *ngIf="message.error" class="ai-error-state">{{ message.error }}</div>

        <div *ngIf="(message.blocks || []).length > 0" class="ai-assistant-visuals">
          <ng-container *ngFor="let block of message.blocks || []" [ngSwitch]="block.type">
            <app-response-task-list    *ngSwitchCase="'task-list'"    [block]="asTaskList(block)"></app-response-task-list>
            <app-response-asset-list   *ngSwitchCase="'asset-list'"   [block]="asAssetList(block)"></app-response-asset-list>
            <app-response-narration-graph *ngSwitchCase="'narration-graph'" [block]="asNarrationGraph(block)"></app-response-narration-graph>
            <app-response-card-narration  *ngSwitchCase="'card-narration'"  [block]="asCardNarration(block)"></app-response-card-narration>
            <app-response-only-narration  *ngSwitchCase="'only-narration'"  [block]="asOnlyNarration(block)"></app-response-only-narration>
            <app-response-task-context    *ngSwitchCase="'task-context'"    [block]="asTaskContext(block)"></app-response-task-context>
            <app-response-task-lineage    *ngSwitchCase="'task-lineage'"    [block]="asTaskLineage(block)"></app-response-task-lineage>
            <app-response-action-items    *ngSwitchCase="'action-items'"    [block]="asActionItems(block)"></app-response-action-items>
            <app-response-follow-up       *ngSwitchCase="'follow-up'"       [block]="asFollowUp(block)" (followUpSelected)="followUpSelected.emit($event)"></app-response-follow-up>
            <div *ngSwitchCase="'branch-narration'" class="ai-markdown ai-branch-narration" [innerHTML]="renderMarkdown(asBranchNarration(block).text)"></div>
          </ng-container>
        </div>

      </div>
      </div><!-- /ai-response-card -->

      <app-ai-feedback-actions
        *ngIf="!message.streaming || message.audit"
        [audit]="message.audit || null"
        (auditRequested)="auditRequested.emit($event)"
      ></app-ai-feedback-actions>
    </div>
  </ng-container>

</article>
